import { render, staticRenderFns } from "./DiscountSingleDetails.vue?vue&type=template&id=7e05ba16&"
import script from "./DiscountSingleDetails.vue?vue&type=script&lang=js&"
export * from "./DiscountSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports